/**
 * @file Resolves the display name of a country subdivision from its code.
 */

import { subdivision } from "iso-3166-2";

/**
 * Resolves the region's display name, or the code itself when the region is unknown.
 */
const getRegionNameByCountryAndRegionCode = (
  countryCode: string,
  regionCode: string,
): string => {
  const region = subdivision(`${countryCode}-${regionCode}`);

  if (!region) {
    return regionCode;
  }

  const { name } = region;

  return name;
};

export default getRegionNameByCountryAndRegionCode;
